import { render, staticRenderFns } from "./selected-text-email-form.vue?vue&type=template&id=b2c508a2"
import script from "./selected-text-email-form.vue?vue&type=script&lang=js"
export * from "./selected-text-email-form.vue?vue&type=script&lang=js"
import style0 from "./selected-text-email-form.vue?vue&type=style&index=0&id=b2c508a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports